const USER_KEY = 'userTrackingId';
let inMemoryUserKey: string | null = null;

function generateUniqueId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // Fallback if crypto is not available
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

function isLocalStorageAvailable(): boolean {
  try {
    const testKey = '__test__';
    localStorage.setItem(testKey, testKey);
    localStorage.removeItem(testKey);
    return true;
  } catch {
    return false;
  }
}

function setLocalStorageItem(key: string, value: string): boolean {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

function getLocalStorageItem(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function setCookie(name: string, value: string, days: number): void {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = `${name}=${value}${expires}; path=/`;
}

function getCookie(name: string): string | null {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let c of ca) {
    c = c.trimStart();
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
  }
  return null;
}

export function getOrCreateUserId(): string {
  if (inMemoryUserKey) {
    return inMemoryUserKey;
  }

  let userKey: string | null = null;

  if (isLocalStorageAvailable()) {
    userKey = getLocalStorageItem(USER_KEY);
    if (userKey) {
      inMemoryUserKey = userKey;
      return userKey;
    }
  }

  userKey = getCookie(USER_KEY);
  if (userKey) {
    inMemoryUserKey = userKey;
    return userKey;
  }

  // Create new UUID
  userKey = generateUniqueId();

  if (isLocalStorageAvailable() && setLocalStorageItem(USER_KEY, userKey)) {
    // Stored in localStorage
  } else {
    setCookie(USER_KEY, userKey, 30); // fallback to cookie
  }

  inMemoryUserKey = userKey;
  return userKey;
}